export * from './authConfiguration';